import { Link } from 'react-router-dom'
import { useEffect } from 'react'
import CustomModal from '../CustomModal'
import TextEditor from '../../../../TextEditor'
import { Input, ModalBody, ModalFooter } from 'reactstrap'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useDispatch } from 'react-redux'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'

const AddHtml = (props) => {
  const dispatch = useDispatch()
  let language = props.language || {}

  useEffect(() => {
    props.manageHtml('')
    props.onChangeTitleText('')
    return () => {
      props.onChangeNewText('')
    }
  }, [])

  return (
    <CustomModal
      courseId={props.course_id}
      title={language.courses ? language.courses.add_html : null}
      size='lg'
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          props.addHtml()
          dispatch(invalidateCoursesOverview())
        }}
      >
        <ModalBody>
          <div>
            <div className='title-container'>
              <div className='mb-2 col-md-6 px-0'>
                <Input
                  type='text'
                  name='title'
                  placeholder={language?.settings?.title}
                  autoFocus
                  value={props.title ? props.title : ''}
                  onChange={(event) =>
                    props.onChangeTitleText(event.target.value)
                  }
                />
              </div>
            </div>
          </div>

          <TextEditor
            textContent={props.html}
            onChangeText={(e) => props.manageHtml(e)}
            setOptions={{
              buttonList: [
                [
                  'undo',
                  'redo',
                  'font',
                  'fontSize',
                  'formatBlock',
                  'list',
                  'align',
                  'fontColor',
                ],
                ['bold', 'underline', 'italic', 'horizontalRule'],
                ['codeView', 'outdent', 'indent'],
                ['table', 'image', 'link'],
              ],
            }}
          />

          <div className='custom-control custom-checkbox-info mt-2'>
            <input
              className='custom-control-input'
              id='required_content'
              type='checkbox'
              checked={props.requiredContent}
              onChange={props.setRequired}
            />
            <label
              className='custom-control-label '
              htmlFor='required_content'
              style={{ fontSize: '14px', paddingTop: '2px' }}
            >
              {language?.courses?.required}
            </label>
          </div>
        </ModalBody>

        <ModalFooter className='justify-content-start '>
          {/* <button className='btn btn-info  mr-2' type='submit'>
            {language?.general?.submit}
          </button> */}
          <SubmitModalButton text={language?.general?.submit} />
          <Link to={`/course/${props.course_id}/edit`}>
            <CancelModalButton text={language?.general?.cancel} />
          </Link>
        </ModalFooter>
      </form>
    </CustomModal>
  )
}

export default AddHtml
